export const confirmPassword = (payload: string) => ({
  type: "@saga/CONFIRM_PASSWORD",
  payload,
});
